import { Card, CardBody } from '@fold-and-flow/ui'
import { Link } from '@tanstack/react-router'
import { trpc } from '#lib/trpc'

export function AdminDashboardPage() {
  const { data: users } = trpc.admin.listUsers.useQuery()
  const { data: recentSessions } = trpc.admin.recentSessions.useQuery({ limit: 10 })

  const clientCount = users?.filter((u) => u.role === 'client').length ?? 0

  return (
    <div className="flex flex-col gap-8">
      <div>
        <h1 className="font-serif text-3xl text-warm-gray-900">Admin Dashboard</h1>
        <p className="text-warm-gray-400 mt-1">Overview of your community's practice</p>
      </div>

      <div className="grid grid-cols-3 gap-4">
        <Card>
          <CardBody>
            <p className="text-sm text-warm-gray-400">Active clients</p>
            <p className="font-serif text-4xl text-warm-gray-900 mt-1">{clientCount}</p>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <p className="text-sm text-warm-gray-400">Sessions this week</p>
            <p className="font-serif text-4xl text-warm-gray-900 mt-1">
              {recentSessions?.length ?? '—'}
            </p>
          </CardBody>
        </Card>
        <Card>
          <CardBody>
            <p className="text-sm text-warm-gray-400">Quick links</p>
            <div className="flex flex-col gap-1 mt-2">
              <Link
                to="/admin/clips"
                className="text-sm text-terracotta-500 hover:text-terracotta-600"
              >
                → Manage clips
              </Link>
              <Link
                to="/admin/users"
                className="text-sm text-terracotta-500 hover:text-terracotta-600"
              >
                → Manage users
              </Link>
            </div>
          </CardBody>
        </Card>
      </div>

      <div>
        <h2 className="font-serif text-lg text-warm-gray-900 mb-4">Recent Sessions</h2>
        <Card>
          <CardBody>
            {recentSessions && recentSessions.length > 0 ? (
              <div className="divide-y divide-cream-200">
                {recentSessions.map((s) => (
                  <div key={s.id} className="py-3 flex items-center gap-4">
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-warm-gray-600 font-mono">
                        {s.userId.slice(0, 8)}…
                      </p>
                      <p className="text-xs text-warm-gray-400">
                        {new Date(s.startedAt).toLocaleString()}
                      </p>
                    </div>
                    <span
                      className={`text-xs px-2.5 py-1 rounded-full ${
                        s.completedAt
                          ? 'bg-sage-400/10 text-sage-600'
                          : 'bg-warm-gray-100 text-warm-gray-500'
                      }`}
                    >
                      {s.completedAt ? `${Math.round(s.completionRate * 100)}%` : 'in progress'}
                    </span>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-sm text-warm-gray-400">No sessions yet</p>
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  )
}
